import { Locale } from "@/types"
import Cookies from 'js-cookie'
import { CookieName } from './cookies'
import YoonlyService from '@/services/YoonlyService'

type SecureDomain = `https://${string}`

export type LinkObj = {
  [key in Exclude<Locale, "en-US"> | "yoonly"]: Links
}

export type Links = {
  contact: `${SecureDomain}/${string}`| string,
  faq: `${SecureDomain}/${string}`,
  legal: `${SecureDomain}/${string}`
  neat: `${SecureDomain}`
}

const frLinks: Links = {
  contact: 'https://www.travelski.com/instit/nous-contacter',
  faq: 'https://www.travelski.com/instit/questions-reponses',
  legal: 'https://www.travelski.com/instit/cgv',
  neat: "https://assures.neat.eu"
}

const getYoonlyLinks = (): Links => {
  const yoonly = new YoonlyService()
  const { helpSegment, legalSegment } = yoonly.getPathSegments()
  return {
    contact: yoonly.getContactPageUrl(),
    faq: `https://help.yoonly.eu/${helpSegment}/`,
    legal: `https://www.yoonly.eu/${legalSegment}/cgv-consommateurs/`,
    neat: 'https://assures.neat.eu'
  }
}


const getCSELinks = (): Links => {
  const company = Cookies.get(CookieName.COMPANY) || ''
  return {
    contact: `https://cse.travelski.com/page/${company}/nous-contacter`,
    faq: `https://cse.travelski.com/page/${company}/modalites-offre`,
    legal: `https://cse.travelski.com/page/${company}/cgv`,
    neat: "https://assures.neat.eu"
  }
}

export const links: LinkObj = {
  "fr-FR": {
    ...frLinks
  },
  "fr-FR-CSE": getCSELinks(),
  "en-GB": {
    contact: 'https://www.uk.travelski.com/instit/nous-contacter',
    faq: 'https://www.uk.travelski.com/instit/questions-reponses',
    legal: 'https://www.uk.travelski.com/instit/cgv',
    neat: "https://assures.neat.eu"
  },
  "nl-NL": {
    contact: 'https://www.nl.travelski.com/instit/nous-contacter',
    faq: 'https://www.nl.travelski.com/instit/questions-reponses',
    legal: 'https://www.nl.travelski.com/instit/cgv',
      neat: "https://assures.neat.eu"
  },
  "yoonly": {
    ...getYoonlyLinks()
  }
}
